<template>
  <div class="pin-code">
    <input
      type="number"
      class="desktop-only"
      v-model="pinCode"
      @focus="focusHandler()"
      @blur="blurHandler()"
      @keyup="updateTemp($event)"
      @keydown="checkCodeLength($event)"
    />
    <div @click="clickHandler()" class="fake-input mobile-only"></div>
    <div
      class="pin-code__box"
      v-bind:class="{ focused: inputFocus && tempCode.length === 0 }"
    >
      {{ tempCode.charAt(0) }}
    </div>
    <div
      class="pin-code__box"
      v-bind:class="{ focused: tempCode.length === 1 }"
    >
      {{ tempCode.charAt(1) }}
    </div>
    <div
      class="pin-code__box"
      v-bind:class="{ focused: tempCode.length === 2 }"
    >
      {{ tempCode.charAt(2) }}
    </div>
    <div
      class="pin-code__box"
      v-bind:class="{ focused: tempCode.length === 3 }"
    >
      {{ tempCode.charAt(3) }}
    </div>
    <div class="pin-code__box" v-bind:class="{ focused: tempCode.length >= 4 }">
      {{ tempCode.charAt(4) }}
    </div>
  </div>
</template>

<script>
import LoginService from "@/services/LoginService";
export default {
  name: "PinCode",
  data() {
    return {
      pinCode: "",
      tempCode: "",
      inputFocus: false
    };
  },
  mounted() {
    this.$root.$on("onNumericPadKeyPressed", this.onNumericPadKeyPressed);
    this.autoFocusOnMobile();
  },
  methods: {
    focusHandler() {
      this.inputFocus = true;
    },
    clickHandler() {
      this.inputFocus = true;
      // This timeout will delay the "open" event of the numeric pad
      // so that would be executed right *after* the click event,
      // which - otherwise - would also close it immediately
      setTimeout(() => {
        this.$root.$emit("openNumericPad");
      }, 10);
    },
    blurHandler() {
      this.inputFocus = false;
    },
    onNumericPadKeyPressed(key) {
      if (key === "X") {
        this.pinCode = this.pinCode.slice(0, -1);
        this.updateTemp({ key: "Backspace" });
      } else {
        if (!this.maxDigitsReached()) {
          this.pinCode += key;
          this.updateTemp({ key: key + "" });
        }
      }
    },
    updateTemp(event) {
      if (event.key === "Backspace") {
        this.tempCode = this.pinCode.replace(new RegExp("[0-9]", "g"), "•");
      } else if (event.key.match(new RegExp("[0-9]", "g"))) {
        const index = this.pinCode.length - 1;
        this.tempCode =
          this.tempCode.substring(0, index) + this.pinCode.charAt(index);

        setTimeout(() => {
          this.tempCode = this.tempCode.replace(new RegExp("[0-9]", "g"), "•");
        }, 400);
      }
      this.$emit("onUpdate", this.pinCode);
    },
    checkCodeLength(event) {
      if (this.maxDigitsReached() && event.key !== "Backspace") {
        event.preventDefault();
        return;
      }
    },
    maxDigitsReached() {
      const maxDigits = 5;
      return this.pinCode.length >= maxDigits;
    },
    autoFocusOnMobile() {
      setTimeout(() => {
        if (
          LoginService.getFromApp() === true ||
          this.$store.state.detect.platform.type === "mobile"
        ) {
          this.$root.$emit("openNumericPad");
        }
      }, 300);
    }
  }
};
</script>

<style scoped lang="less">
.pin-code {
  display: flex;
  position: relative;
  justify-content: space-between;
  max-width: 300px;
  margin: 0 auto;
  input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  .fake-input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
  }
  &__box {
    width: 45px;
    height: 45px;
    font-size: 25px;
    border: 1px solid #eaeaea;
    padding: 5px 10px 0 10px;
    text-align: center;
    border-radius: 5px;
    &.focused {
      border: 1px solid #000000;
    }
  }
}
</style>
